import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN}.${BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.KEY_ASSUMPTIONS}` as const;

export const KEY_ASSUMPTIONS_NAMES = {
  EXPECTED_REVENUE_VOLUME: 'expectedRevenueVolume',
  INCREASE_FACTORS: 'increaseFactors',
  CHANGE_IN_PRICES: 'changeInPrices',
  SEASONALITY_AND_ECONOMIC_CYCLES_AFFECTION: 'seasonalityAndEconomicCyclesAffection',
  
  COST_FORMATION: 'costFormation',
  EXPENSES: 'expenses',
  COSTS_INFLUENCE_FACTORS: 'costsInfluenceFactors',
  COST_ESTIMATION: 'costEstimation',
  LOGISTICS_AFFECT: 'logisticsAffect',
  FIXED_COSTS_DISTRIBUTING: 'fixedCostsDistributing',
  RESEARCH_MAIN_COMPONENTS: 'researchMainComponents',
  HIGHEST_PRIORITY_PROJECTS: 'highestPriorityProjects',
  MAIN_COST_COMPONENTS: 'mainCostComponents',
  GENERAL_STRUCTURE: 'generalStructure',
  OTHER_OPERATING_EXPENSES: 'otherOperatingExpenses',
  CONTROL_STRATEGIES: 'controlStrategies',
  FIXED_EXPENSES_TYPES: 'fixedExpensesTypes',
  FINANCIAL_EXPENSES_AMOUNT: 'financialExpensesAmount',
  NON_OPERATING_EXPENSES: 'nonOperatingExpenses',

  TYPES_OF_TAXES: 'typesOfTaxes',

} as const;

export interface IKeyAssumptions {
  [KEY_ASSUMPTIONS_NAMES.EXPECTED_REVENUE_VOLUME]: string;
  [KEY_ASSUMPTIONS_NAMES.INCREASE_FACTORS]: string;
  [KEY_ASSUMPTIONS_NAMES.CHANGE_IN_PRICES]: string;
  [KEY_ASSUMPTIONS_NAMES.SEASONALITY_AND_ECONOMIC_CYCLES_AFFECTION]: string;

  [KEY_ASSUMPTIONS_NAMES.COST_FORMATION]: string;
  [KEY_ASSUMPTIONS_NAMES.EXPENSES]: string;
  [KEY_ASSUMPTIONS_NAMES.COSTS_INFLUENCE_FACTORS]: string;
  [KEY_ASSUMPTIONS_NAMES.COST_ESTIMATION]: string;
  [KEY_ASSUMPTIONS_NAMES.LOGISTICS_AFFECT]: string;
  [KEY_ASSUMPTIONS_NAMES.FIXED_COSTS_DISTRIBUTING]: string;
  [KEY_ASSUMPTIONS_NAMES.RESEARCH_MAIN_COMPONENTS]: string;
  [KEY_ASSUMPTIONS_NAMES.HIGHEST_PRIORITY_PROJECTS]: string;
  [KEY_ASSUMPTIONS_NAMES.MAIN_COST_COMPONENTS]: string;
  [KEY_ASSUMPTIONS_NAMES.GENERAL_STRUCTURE]: string; 
  [KEY_ASSUMPTIONS_NAMES.OTHER_OPERATING_EXPENSES]: string;
  [KEY_ASSUMPTIONS_NAMES.CONTROL_STRATEGIES]: string;
  [KEY_ASSUMPTIONS_NAMES.FIXED_EXPENSES_TYPES]: string;
  [KEY_ASSUMPTIONS_NAMES.FINANCIAL_EXPENSES_AMOUNT]: string;
  [KEY_ASSUMPTIONS_NAMES.NON_OPERATING_EXPENSES]: string;

  [KEY_ASSUMPTIONS_NAMES.TYPES_OF_TAXES]: string;
}

export const keyAssumptionsInitialValues: IKeyAssumptions = {
  [KEY_ASSUMPTIONS_NAMES.EXPECTED_REVENUE_VOLUME]: '',
  [KEY_ASSUMPTIONS_NAMES.INCREASE_FACTORS]: '',
  [KEY_ASSUMPTIONS_NAMES.CHANGE_IN_PRICES]: '',
  [KEY_ASSUMPTIONS_NAMES.SEASONALITY_AND_ECONOMIC_CYCLES_AFFECTION]: '',

  [KEY_ASSUMPTIONS_NAMES.COST_FORMATION]: '',
  [KEY_ASSUMPTIONS_NAMES.EXPENSES]: '',
  [KEY_ASSUMPTIONS_NAMES.COSTS_INFLUENCE_FACTORS]: '',
  [KEY_ASSUMPTIONS_NAMES.COST_ESTIMATION]: '',
  [KEY_ASSUMPTIONS_NAMES.LOGISTICS_AFFECT]: '',
  [KEY_ASSUMPTIONS_NAMES.FIXED_COSTS_DISTRIBUTING]: '',
  [KEY_ASSUMPTIONS_NAMES.RESEARCH_MAIN_COMPONENTS]: '',
  [KEY_ASSUMPTIONS_NAMES.HIGHEST_PRIORITY_PROJECTS]: '',
  [KEY_ASSUMPTIONS_NAMES.MAIN_COST_COMPONENTS]: '',
  [KEY_ASSUMPTIONS_NAMES.GENERAL_STRUCTURE]: '', 
  [KEY_ASSUMPTIONS_NAMES.OTHER_OPERATING_EXPENSES]: '',
  [KEY_ASSUMPTIONS_NAMES.CONTROL_STRATEGIES]: '',
  [KEY_ASSUMPTIONS_NAMES.FIXED_EXPENSES_TYPES]: '',
  [KEY_ASSUMPTIONS_NAMES.FINANCIAL_EXPENSES_AMOUNT]: '',
  [KEY_ASSUMPTIONS_NAMES.NON_OPERATING_EXPENSES]: '',
  [KEY_ASSUMPTIONS_NAMES.TYPES_OF_TAXES]: '',
};
